<template>
  <div class="pravo">
    <div class="pravo__obsah">
      <div class="grid">
        <div class="tabulka full">
          <div class="tabulka__top">
            <div class="tabulka__top__nadpis">User list</div>
          </div>
          <div class="tabulka__body">
            <table>
              <thead>
                <td>
                  <span>ID</span>
                  <SortButton
                    row="id"
                    type="0"
                    :currentSortDirection="currentSortDirection"
                    :currentSortRow="currentSortRow"
                    v-on:sortBy="sortRow"
                  />
                </td>
                <td>
                  <span>Username</span>
                  <SortButton
                    row="username"
                    type="a"
                    :currentSortDirection="currentSortDirection"
                    :currentSortRow="currentSortRow"
                    v-on:sortBy="sortRow"
                  />
                </td>
                <td>
                  <span>Role</span>
                  <SortButton
                    row="role"
                    type="a"
                    :currentSortDirection="currentSortDirection"
                    :currentSortRow="currentSortRow"
                    v-on:sortBy="sortRow"
                  />
                </td>
                <td>
                  <span>Active</span>
                  <SortButton
                    row="active"
                    type="a"
                    :currentSortDirection="currentSortDirection"
                    :currentSortRow="currentSortRow"
                    v-on:sortBy="sortRow"
                  />
                </td>
                <td>
  
                </td>
              </thead>
              <PlayerRow v-for="player in resultData" 
              :key="player.id"
              :player="player"
              />
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SortButton from "@/components/game/table/SortButton.vue";

import PlayerRow from "@/components/gameManager/PlayerRow.vue";
import { mapGetters } from "vuex";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import _ from "lodash";

export default {
  name: "Users",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
    PlayerRow,
  },
  data() {
    return {
      currentSortRow: "role",
      gamesVisible: true,
      renamingTeam: false,
    };
  },
  methods: {
    notMe(id) {
      if (id == this.myId) {
        return false;
      }
      return true;
    },
    deactivate(user) {
      this.$store.dispatch("deactivateUser", user);
    },
    activate(user) {
      this.$store.dispatch("activateUser", user);
    },
  },
  mounted() {
    this.$store.dispatch("fetchAllUsers");
  },
  computed: {
    ...mapGetters({
      sourceData: "allUsers",
    }),
    resultData() {
      return this.sortedData;
    },
  },
};
</script>
